/*
 * The MCP server's info page for developers, like Swagger UI for the REST API: what an assistant
 * gets from the server, read from the server itself. The front-end manifest, see
 * lib/docs/extensions/writing-an-extension.md.
 */
import { defineExtension } from '@lib/extensions/define';

import de from './locale/de';
import en from './locale/en';

export default defineExtension({
	name: 'mcp',
	locale: { de, en },
	routes: [
		{
			path: 'admin/mcp',
			name: 'mcp.info',
			component: () => import('./pages/McpInfo.vue'),
			meta: { permissions: ['app.developer'] },
		},
	],
	// Beside Swagger UI; the app places extensionMenu('admin', ...) in its menu
	sidebar: {
		admin: () => [{ to: '/admin/mcp', icon: 'fa-robot', label: 'mcp', permissions: ['app.developer'] }],
	},
});
